import type { SearchIndex } from 'algoliasearch';
import { createAlgoliaClient } from '../client/algoliaClient';
import { AlgoliaIndice } from '../types';

export const getSearchIndex = (
    indexName = AlgoliaIndice.PRODUCTS,
    opts: { admin?: boolean } = { admin: false }
): SearchIndex => createAlgoliaClient(opts).initIndex(indexName);
